import { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from '@calendly/ui/components/button'
import { nanoid } from 'nanoid'
import styled from 'astroturf/react'
import { Recaptcha } from '@calendly/recaptcha'
import { Segment } from '@calendly/segment'

import { withI18n } from 'locales'
import { isMultipleLocation, isWithoutLocation } from 'services/location'
import TextField from 'components/form/text'
import IntercomConfirmation from 'components/enter_details/intercom_confirmation'
import MultipleLocation from 'components/location/multiple'
import SingleLocation from 'components/location/single'
import CustomFields from 'components/custom_fields'
import TextReminder from 'components/text_reminder'
import CanceledByField from 'components/canceled_by_field'
import PaymentSummary from 'components/payment/summary'
import { formFieldUpdated, formUnmounted, selectLocationConfiguration, submitScheduling } from 'actions/scheduling'
import { dismissScheduleError, dismissValidationError } from 'actions/errors'
import {
  locationConfigurationsSelector,
  ignoreLocationConfigurationsSelector,
  showMailchimpInviteeConsentSelector
} from 'selectors/event_type'
import { eventTypeSelector } from 'root-api'
import {
  canceledByRequiredSelector,
  eventSelector,
  inviteeGuestsErrorsSelector,
  inviteeInvalidGuestEmailsSelector,
  isPublisherSelector,
  singleLocationConfigurationSelector
} from 'selectors'
import { currentInviteeSelector } from 'selectors/current_invitee'
import { nameSelector } from 'selectors/invitee'
import { buildRequestId } from 'services/request_id'
import { buildNewInvitee } from 'services/invitee'
import { EmailInput } from 'components/invitee_inputs'

import BookingField from '../booking_field'
import GuestsField from '../fields/guest'
import _FormWrapper from "rescheduling_form-FormWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/rescheduling_form.js?styleId=FormWrapper";
import _StyledCanceledByField from "rescheduling_form-StyledCanceledByField.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/rescheduling_form.js?styleId=StyledCanceledByField";
import _GuestsCommentContainer from "rescheduling_form-GuestsCommentContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/rescheduling_form.js?styleId=GuestsCommentContainer";
import _PaymentInfoTitle from "rescheduling_form-PaymentInfoTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/rescheduling_form.js?styleId=PaymentInfoTitle";
import _StyledPaymentSummary from "rescheduling_form-StyledPaymentSummary.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/rescheduling_form.js?styleId=StyledPaymentSummary";
import _ReschedulingReasonTextField from "rescheduling_form-ReschedulingReasonTextField.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/rescheduling_form.js?styleId=ReschedulingReasonTextField";


const FormWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormWrapper",
  styles: _FormWrapper
})

const StyledCanceledByField = /*#__PURE__*/styled(CanceledByField, null, {
  displayName: "StyledCanceledByField",
  styles: _StyledCanceledByField
})

const GuestsCommentContainer = /*#__PURE__*/styled('div', null, {
  displayName: "GuestsCommentContainer",
  styles: _GuestsCommentContainer
})
const PaymentInfoTitle = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentInfoTitle",
  styles: _PaymentInfoTitle
})

const StyledPaymentSummary = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "StyledPaymentSummary",
  styles: _StyledPaymentSummary
})

const ReschedulingReasonTextField = /*#__PURE__*/styled(TextField, null, {
  displayName: "ReschedulingReasonTextField",
  styles: _ReschedulingReasonTextField
})

class ReschedulingForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      event: { location: '', event_guests: this.props.event.guests },
      invitee: this.buildInviteeState(),
      inviteeGuests: this.buildInviteeGuests(),
      event_fields: this.buildEventFieldsState(),
      location_configuration: this.buildLocationConfiguration(),
      recaptchaVerifyCallback: () => Promise.resolve(null)
    }
  }

  componentDidMount() {
    this.props.dismissError()
    this.onGuestsChange()
  }

  componentWillUnmount() {
    this.props.onFieldUnmount()
  }

  onInviteeFieldChange = (event) => {
    this.props.onFieldUpdated(event.target.name, event.target.value)
    return this.setModelState('invitee', event.target.name,
      { value: event.target.value })
  }

  onCustomFieldChange = (index, props) => {
    this.props.onFieldUpdated(`question_${index}`, props.value)
    return this.setCustomFieldState(index, props)
  }

  onTextReminderChange = (props) => {
    this.props.onFieldUpdated('phone_number', props.value)
    return this.setModelState('invitee', 'phone_number', props)
  }

  onSubmit = (event) => {
    event.preventDefault()

    const requestId = buildRequestId(
      this.props.requestKeySalt,
      this.props.spotStartTime,
      this.props.event_type.uuid,
      this.props.inviteeName
    )

    return this.props.onSubmit(
      this.state,
      this.paymentApi,
      this.props.currentInvitee,
      requestId
    )
  }


  render() {
    const isPublisher = this.props.isPublisher
    const hasPackageFulfillment = this.props.event.package_fulfillment_uuid

    return (
      <form
        autoComplete="off"
        autoCorrect="off"
        noValidate
        onSubmit={this.onSubmit}
      >
        <FormWrapper>
          {this.renderRecaptcha()}
          {isPublisher && !hasPackageFulfillment && (
            <>
              {this.renderEmailInput()}
              {this.isEventGuestsEnabled() && this.renderInviteeGuests()}
            </>
          )}
          {this.renderCanceledByInput()}
          {this.renderReschedulingReason()}
          {this.renderLocation()}
          {this.renderCustomFields()}
          {this.renderTextReminder()}
          {this.renderPaymentInfo()}
          {this.renderIntercomConfirmation()}
        </FormWrapper>
        <Button
          type="submit"
          size="large"
          loading={this.props.status === 'submitting'}
        >
          {this.props.i18n.t('booking.templates.update_event')}
        </Button>
        {this.renderReschedulingGuestsComment()}
      </form>
    )
  }

  renderRecaptcha() {
    return (
      <Recaptcha
        action="rescheduling"
        setVerifyCallback={this.setRecaptchaVerifyCallback}
        onError={this.recaptchaEnqueueAnalytic}
      />
    )
  }

  renderCanceledByInput() {
    if (!this.props.canceledByRequired) { return null }
    return (
      <StyledCanceledByField
        onChange={this.onInviteeFieldChange}
      />
    )
  }

  renderLocation() {
    if (isWithoutLocation(this.props.ignoreLocationConfigurations, this.props.locationConfigurations)) { return null }

    if (isMultipleLocation(this.props.locationConfigurations)) {
      return <MultipleLocation />
    }
    return <SingleLocation />
  }

  renderCustomFields() {
    return (
      <CustomFields
        fields={this.state.event_fields}
        onChange={this.onCustomFieldChange}
      />
    )
  }

  renderTextReminder() {
    if (!this.props.event_type.sms_reminder_enabled) { return null }

    return (
      <TextReminder
        value={this.state.invitee.phone_number.value}
        required={this.state.invitee.phone_number.required}
        onChange={this.onTextReminderChange}
      />
    )
  }

  renderPaymentInfo() {
    if (!(this.props.currentInvitee.charge != null ? this.props.currentInvitee.charge.captured : undefined)) { return null }
    return (
      <>
        <PaymentInfoTitle>{this.props.i18n.t('booking.templates.payment.information')}</PaymentInfoTitle>
        <StyledPaymentSummary
          charge={this.props.currentInvitee.charge}
          rescheduleNote={!this.props.isPublisher}
        />
      </>
    )
  }

  renderIntercomConfirmation() {
    if (!this.props.isSubmittingIntercomSheet) { return null }
    return <IntercomConfirmation />
  }

  renderEmailInput() {
    return (
      <BookingField>
        <EmailInput email={this.state.invitee.email} onChange={this.onInviteeFieldChange} />
      </BookingField>
    )
  }

  isEventGuestsEnabled() {
    return this.props.event_type.guests_allowed
  }

  onGuestsAdd = (email) => {
    this.setState((state) => ({
      inviteeGuests: [].concat(state.inviteeGuests, this.buildInviteeGuest(email))
    }), this.onGuestsChange)
  }

  onGuestsRemove = (guestId) => {
    this.setState(
      (prevState) => ({
        inviteeGuests: prevState.inviteeGuests.filter(({ id }) => id !== guestId),
      }), this.onGuestsChange,
    )
  }

  onGuestsUpdate = (guestId, newEmail) => {
    if (!newEmail) {
      this.onGuestsRemove(guestId)
      return
    }

    this.setState((prevState) => ({
      inviteeGuests: prevState.inviteeGuests.map(({ id, email }) => ({
        id,
        email: id === guestId ? newEmail : email,
      }), this.onGuestsChange),
    }))
  }

  onGuestsChange = () => {
    const uniqEmails = Array.from(new Set(this.state.inviteeGuests.map(({ email }) => email)))
    return this.setModelState('event', 'guest_emails', uniqEmails)
  }

  renderInviteeGuests() {
    return (
      <GuestsField
        guests={this.state.inviteeGuests}
        onAdd={this.onGuestsAdd}
        onRemove={this.onGuestsRemove}
        onUpdate={this.onGuestsUpdate}
        errors={this.props.guestErrors}
        invalidEmails={this.props.invalidGuestEmails}
        dismissError={this.props.dismissGuestsErrors}
      />
    )
  }

  renderReschedulingReason() {
    return (
      <ReschedulingReasonTextField
        label={this.props.i18n.t('booking.templates.reason_for_change')}
        name="cancel_reason"
        type="textarea"
        value={this.state.invitee.cancel_reason.value}
        onChange={this.onInviteeFieldChange}
      />
    )
  }

  renderReschedulingGuestsComment() {
    if (!this.props.event.guests.length) { return null }
    return (
      <GuestsCommentContainer>
        <small>
          {
          this.props.i18n.t('booking.templates.rescheduling_guests_comment', {
            count: this.props.event.guests.length,
            invitee_name: this.props.inviteeName
          })
        }
        </small>
      </GuestsCommentContainer>
    )
  }


  buildInviteeAttribute(attribute, required) {
    const value = this.getInviteeValue(attribute)
    this.props.onFieldUpdated(attribute, value)

    return {
      name: attribute,
      required,
      value
    }
  }

  buildInviteeState() {
    const state = {}

    switch (this.props.event_type.invitee_name_format) {
      case 'separated':
        state.first_name = this.props.currentInvitee.first_name
          ? this.buildInviteeAttribute('first_name', true)
          : this.buildInviteeAttribute('full_name', true)
        state.last_name = this.buildInviteeAttribute('last_name', true)

        if (!state.last_name.value) {
          state.last_name = { ...state.last_name, value: ' ' }
        }
        break
      case 'combined':
        state.full_name = this.buildInviteeAttribute('full_name', true)
        break
      default:
    }

    state.email = this.buildInviteeAttribute('email', true)

    state.cancel_reason = this.buildInviteeAttribute('cancel_reason', false)

    if (this.props.canceledByRequired) {
      state.canceled_by = this.buildInviteeAttribute('canceled_by', true)
    }

    if (this.props.event_type.sms_reminder_enabled) {
      state.phone_number = this.buildInviteeAttribute('phone_number', false)
    }

    return state
  }

  buildInviteeGuest = (email) => ({
    id: nanoid(5),
    email,
  })

  buildInviteeGuests() {
    return this.props.event.guests.map(this.buildInviteeGuest)
  }

  buildEventFieldsState() {
    const { customFields, currentInvitee: { questions_and_answers: predefinedAnswers } } = this.props

    return customFields.map((field) => {
      const answer = predefinedAnswers.find((a) => a.position === field.position && a.question === field.name)?.answer || ''

      let fieldValue

      switch (field.format) {
        case 'choices_one':
          fieldValue = (field.answer_choices.indexOf(answer) + 1).toString()
          break
        case 'choices_many':
          fieldValue = answer.split('\n').map((part) => field.answer_choices.indexOf(part) + 1).join(',')
          break
        default:
          fieldValue = answer
      }

      return (
        {
          ...field,
          value: fieldValue
        }
      )
    })
  }

  buildLocationConfiguration() {
    if (this.props.event_type.location_configurations.length === 0) { return null }
    return this.props.event_type.location_configurations[0]
  }


  setModelState(model, attribute, value) {
    const isTrueObject = (possibleObject) => (typeof possibleObject === 'object') && !Array.isArray(possibleObject)

    return this.setState((prevState) => ({
      [model]: { ...prevState[model], ...{ [attribute]: isTrueObject(value) ? { ...prevState[model][attribute], ...value } : value } },
    }))
  }

  setCustomFieldState(index, props) {
    this.setState((state) => {
      const newEventFields = state.event_fields.slice()
      newEventFields[index] = Object.assign({}, newEventFields[index], props)
      return { event_fields: newEventFields }
    })
  }

  setRecaptchaVerifyCallback = (recaptchaVerifyCallback) => {
    this.setState({ recaptchaVerifyCallback })
  }

  recaptchaEnqueueAnalytic = (type) => {
    Segment.track('abuse_prevention.recaptcha.token_generation', {
      action: 'rescheduling',
      type
    })
  }

  getInviteeValue(attribute) {
    const { autofillData, currentInvitee } = this.props
    const newInvitee = buildNewInvitee()

    return newInvitee[attribute] || (currentInvitee || {})[attribute] || autofillData[attribute] || ''
  }
}


const mapStateToProps = (state) => ({
  isPublisher: isPublisherSelector(state),
  status: state.scheduling.status,
  event_type: eventTypeSelector(state),
  event: eventSelector(state),
  customFields: eventTypeSelector(state).custom_fields,
  predefined_answers: state.predefined_answers,
  currentInvitee: currentInviteeSelector(state),
  inviteeName: nameSelector(state),
  guestErrors: inviteeGuestsErrorsSelector(state),
  invalidGuestEmails: inviteeInvalidGuestEmailsSelector(state),
  canceledByRequired: canceledByRequiredSelector(state),
  isSubmittingIntercomSheet: state.scheduling.is_submitting_intercom,
  locationConfigurations: locationConfigurationsSelector(state),
  singleLocationConfiguration: singleLocationConfigurationSelector(state),
  ignoreLocationConfigurations: ignoreLocationConfigurationsSelector(state),
  showMailchimpInviteeConsent: showMailchimpInviteeConsentSelector(state),
})


const mapDispatchToProps = (dispatch, ownProps) => ({
  onFieldUpdated(name, value) {
    dispatch(formFieldUpdated(name, value))
  },

  onFieldUnmount() {
    dispatch(formUnmounted())
  },

  onSubmit(formData, paymentApi, currentInvitee, requestId) {
    dispatch(submitScheduling(ownProps.spotStartTime, formData, paymentApi, currentInvitee, requestId))
  },

  dismissError() {
    dispatch(dismissScheduleError())
  },

  dismissValidationError(model, attribute) {
    dispatch(dismissValidationError(model, attribute))
  },

  dismissGuestsErrors() {
    dispatch(dismissValidationError('event', 'event_guests'))
    dispatch(dismissValidationError('event', 'event_guests_emails'))
  },

  onLocationSelected(locationConfiguration) {
    dispatch(selectLocationConfiguration(locationConfiguration))
  }
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n(ReschedulingForm))
